import {Box} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {Theme} from '@material-ui/core/styles';
import {observer} from 'mobx-react';
import {Route,Switch,useHistory,useParams} from 'react-router-dom';
import {useCommunicationRoutesConfig} from './hooks';
import {useDealRoomTopicComunicationStore} from './hooks/useDealRoomTopicCommunicationStore';
import {MyChatContainer,SelectConversation} from './myChatContainer';
import {FilterType} from './types/communicationTypes';

const useStyles=makeStyles((theme: Theme) => ({
  chatContainer: {
    flex: 1,
  },
}));

interface DealRoomConversationProps {
  showEmailAddress?: boolean;
  proposalId?: string;
}

export const DealRoomTopicConversationInternal=observer(
  ({
    showEmailAddress = false,
  }: DealRoomConversationProps) => {
    const classes = useStyles();

    const params = new URLSearchParams(location.search);

    const userId = parseInt(params.get('userId'))
    const proposalTopicId = parseInt(params.get('proposalTopicId'))
    const { dealRoomTopicCommunicationStore } = useDealRoomTopicComunicationStore();

    const { communicationRoutesConfig } = useCommunicationRoutesConfig();
    const { push } = useHistory();

    return (
      <Switch>
        <Route path={communicationRoutesConfig.dealRoomTopicsConversations.path}>
          <>
            <Box display="flex" width={'100%'}>
              <MyChatContainer
                id={Number(proposalTopicId)}
                communicationStore={dealRoomTopicCommunicationStore}
                allowNewConversations={false}
                allowJoinConversation={true}
                showEmailAddress={showEmailAddress}
                showSnippet={false}
                allowRemoveParticipants={true}
                allowManageParticipants={true}
                allowAddInternalParticipants={true}
                onConversationSelect={conversationId =>
                  push(
                    communicationRoutesConfig
                      .dealRoomTopicsConversations
                      .children.conversation(conversationId).url
                  )
                }
                className={classes.chatContainer}
                filterType={FilterType.DEAL_ROOM_TOPIC}
              />
            </Box>
            <Switch>
              <Route
                exact
                path={
                  communicationRoutesConfig
                    .dealRoomTopicsConversations
                    .children.conversation().path
                }
              >
                <SelectConversation
                  communicationStore={dealRoomTopicCommunicationStore}
                />
              </Route>
            </Switch>
          </>
        </Route>
      </Switch>
    );
  }
);
